import { Component, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { PDFExportComponent } from '@progress/kendo-angular-pdf-export';
import { Keys } from 'app/models/core/dropdowns';
import { ISearchLabs, ISearchLabsParameters } from 'app/models/searchLabs/searchLabs';
import { SettingsService } from 'app/services/core/settings.service';
import { SearchLabsService } from 'app/services/searchLabs/searchLabs.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LabApplicationMenuService } from 'app/services/application-menu/lab-application-menu.service';
import { SharedService } from '@shared/services/shared.service';
import { IApplicationFeeCalculationViewModel, IApplicationFeeModel, IApplicationFeeReportViewModel, IApplicationMethodsViewModel, IApplicationReportViewModel, IApplicationTechnologyReport, IApplicationTechnologyViewModel } from 'app/models/reports/reports';
import { SubmitApplicationService } from 'app/services/application-menu/submit-application.service';
import { ICalculatedFees } from 'app/models/application-menu/calculated-fees';

@Component({
  selector: 'applicationFeesReport',
  templateUrl: './applicationFeesReport.component.html',
  styleUrls: ['./applicationFeesReport.component.scss']
})
export class ApplicationFeesReportComponent {
  @ViewChild('pdf') pdf: PDFExportComponent;

  public feeModel: IApplicationFeeCalculationViewModel={
      title: '',
      labName: '',
      applicationType: '',
      user: '',
      basicMultiplier: 0,
      moderateMultiplier: 0,
      complexMultiplier: 0,
      advancedMultiplier: 0,
      miscMultiplier: 0,
      basicFots: 0,
      moderateFots: 0,
      complexFots: 0,
      advancedFots: 0,
      miscFots: 0,
      assessmentFee: 0,
      applicationFee: 0,
      onSiteFee: 0,
      totalFee: 0,
      feeTier1: 0,
      feeTier2: 0,
      feeTier3: 0,
      feeTier4: 0,
      feeTier5: 0
    };
  public feeData: IApplicationFeeModel = {
    orelapId: '',
    applicationId: 0,
    appFeeCategory: [],
    appFeeData: this.feeModel
  };
  
  public feeCategory: IApplicationFeeReportViewModel[];

  public orelapId: string;
  public appId: string;
  public now: string = new Date().toDateString();



  calculatedFees: ICalculatedFees = {
    appId: this.sharedService.currentApplication.labApplicationId,
    advancedMultiplier: 0,
    applicationFee: 0,
    applicationTripFee: 0,
    applicationType: '',
    assessmentFee: 0,
    basicMultiplier: 0,
    complexMultiplier: 0,
    feesProcessed: true,
    inState: false,
    labName: '',
    login: '',
    miscMultiplier: 0,
    moderateMultiplier: 0,
    onSite: false,
    orelapId: '',
    tierOneFee: 0,
    tierThreeFee: 0,
    tierTwoFee: 0
  };

  public groupedFees: {
    complexity: string, 
    fot: IApplicationFeeReportViewModel[] }[] = [];

  constructor(public searchLabsService: SearchLabsService,
    private submitApplicationService: SubmitApplicationService,
    public settings: SettingsService,
    private dialogRef: MatDialogRef<ApplicationFeesReportComponent>,
    private labApplicationMenuService: LabApplicationMenuService,
    private sharedService: SharedService
  ) {
    console.log('application fee report for application', this.sharedService.currentApplication);
    this.submitApplicationService.getApplicationFeeReport
      ( this.sharedService.currentApplication.labApplicationId).subscribe(
          response => {
            console.log('application fee report response', response);
            this.feeData = response;
            this.feeModel = response.appFeeData;
            this.grouped(this.feeData.appFeeCategory);
          },
          error => console.log('error', error)
        );
  }

  grouped(technologies: IApplicationFeeReportViewModel[]): void {
    // First group by name
    const byComplexity: { [key: string]: IApplicationFeeReportViewModel[] } = {};
    technologies.forEach(ft => {
      if (!byComplexity[ft.category]) {
        byComplexity[ft.category] = [];
      }
      byComplexity[ft.category].push(ft);
    });

    this.groupedFees = Object.keys(byComplexity).map(complexity => ({
      complexity,
      fot: byComplexity[complexity]
    }));

  }

  ngOnInit(): void {
  }

  feeSummary(feeList: IApplicationFeeReportViewModel[]): number {
    let subtotal = 0;
    feeList.forEach(fee => {
      subtotal += fee.fieldOfTestingSubtotal;
    });
    return subtotal;
  }

  printReport(): void {
    if (this.pdf) {
      this.pdf.saveAs('ORELAP_Fees_Report.pdf');
    }
    this.closeDialog();
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

}
